module.exports = __webpack_public_path__ + "static/yapay-zeka-danismanligi-banner-4d54447b701d374766291e3a18e9cad1.webp";